module.exports = "../images/newsletter-image@2x.jpg?v=d643e7f";